import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  async open(event) {
    event.preventDefault();

    const url = event.currentTarget.href;
    const frame = document.getElementById("pupil_location_quick_look");
    if (!frame) return;

    const response = await fetch(url, {
      method: "GET",
      headers: { Accept: "text/html" },
      credentials: "same-origin",
    });

    if (!response.ok) return;

    frame.outerHTML = await response.text();
  }

  async save(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const response = await fetch(form.action, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken(),
        Accept: "text/vnd.turbo-stream.html",
      },
      body: new FormData(form),
      credentials: "same-origin",
    });

    const body = await response.text();
    if (response.ok) {
      window.location.reload();
      return;
    }

    if (body.trim().length > 0) {
      Turbo.renderStreamMessage(body);
    }
  }

  close(event) {
    event.preventDefault();

    const frame = document.getElementById("pupil_location_quick_look");
    if (frame) {
      frame.innerHTML = "";
    }
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || "";
  }
}
